export default "__VITE_ASSET__Ce4aJAxK__"